'use client';

import { isOneTrustReady } from '@jouzen/onetrust-consent-manager';
import { useGateValue } from '@statsig/react-bindings';
import { useCallback, useEffect, useRef } from 'react';

import isBrowser from '@/utils/isBrowser';

const usePageView = (pageName: string): void => {
  // TODO: Remove after OneTrust CM rollout - remove gate check and legacy refs
  const isOneTrustEnabled = useGateValue('onetrust_segment_consent_manager');
  const pageLoaded = useRef(false);
  const sent = useRef(false);

  // TODO: Remove after OneTrust CM rollout - remove hasLegacyCMProps
  const hasLegacyCMProps = pageName && !pageLoaded.current;
  const hasOneTrustCMProps = pageName && !sent.current;

  const pageViewed = useCallback(async () => {
    if (isBrowser()) {
      await window.ouraAnalytics.page(pageName);
    }
  }, [pageName]);

  // TODO: After OneTrust CM rollout - remove isOneTrustEnabled check only
  // handles page views when OneTrust is ready
  useEffect(() => {
    if (!hasOneTrustCMProps || !isOneTrustEnabled || !isOneTrustReady()) return;

    async function checkAndSend() {
      if (!sent.current) {
        sent.current = true; // Set this immediately to prevent duplicate calls
        await pageViewed();
        pageLoaded.current = true;
      }
    }

    // Poll every 100ms until ready
    const interval = setInterval(checkAndSend, 100);
    return () => clearInterval(interval);
  }, [hasOneTrustCMProps, isOneTrustEnabled, pageViewed]);

  // TODO: Remove after OneTrust CM rollout - delete this entire useEffect
  // handles page views on Component change/browser refresh only (if OneTrust is disabled)
  useEffect(() => {
    if (!isOneTrustEnabled && hasLegacyCMProps) {
      void pageViewed();
    }
    pageLoaded.current = true;
  }, [isOneTrustEnabled, hasLegacyCMProps, pageViewed]);
};

export default usePageView;
